import { render, staticRenderFns } from "./ProjectDeliveryDateUpdate.vue?vue&type=template&id=7d70d535&"
import script from "./ProjectDeliveryDateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliveryDateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports